import styled from "styled-components";

export const SelectBillingTypeContainer = styled.div`
  width: 750px;
  height: 480px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const SelectBillingTypeContainerContent = styled.div`
  width: 70%;
  height: 160px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const SelectBillingTypeContainerContentBox = styled.div`
  width: 200px;
  height: 130px;
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 5px;
  background-color: #80bd01;
  cursor: pointer;
  transition: 0.3s;
  p {
    font-size: 20px;
    font-family: "Akrobat ExtraBold";
    letter-spacing: 0.04rem;
    color: white;
    text-align: center;
    position: relative;
    margin-left: auto;
    margin-right: auto;
  }

  &:hover {
    transition: 0.3s;
    transform: scale(1.1, 1.1);
  }
`;
